module.exports = __webpack_public_path__ + "img/polish.04b9808.webp";